module.exports = __webpack_public_path__ + "img/passing.2e5b59b5.png";